module.exports = __webpack_public_path__ + "img/ykhome2.9c8ba7e3.png";